// @ts-strict-ignore
import {Pipe, PipeTransform} from "@angular/core";
import {SimVOGSetService} from "@services";
import {from, Observable, of} from "rxjs";
import {VOGSet} from "@models";

@Pipe({
	name: "getVogSetById",
	standalone: false,
})
export class GetVogSetByIdPipe implements PipeTransform {
	constructor(private _simVogSetService: SimVOGSetService) {}

	transform(vogSetId: string): Observable<VOGSet> {
		if (!vogSetId) {
			return of(null);
		}
		return from(this._simVogSetService.getVogSetById(vogSetId));
	}
}
